import * as amplitude from './amplitude'
import * as common from './common'
import * as events from './events'

const Crezu = { amplitude, common, events }

export default Crezu



// WEBPACK FOOTER //
// ./src/utils/index.js